import { DownloadFunctionality } from "../../components/downloadFunctionality";

const arrayHref = [
  {
    href: "https://play.google.com/store/apps/details?id=com.imadeabug.wordsort",
    src: "/GooglePlayBadge.svg",
    alt: "GooglePlay",
  },
  {
    href: "https://apps.apple.com/us/app/word-sort-a-crossword-twist/id6742403603",
    src: "/AppStoreBadge.svg",
    alt: "AppStore",
  },
];

export const WordSort = () => {
  return (
    <div className="flex flex-col sm:flex-row flex-1 justify-center items-center gap-6 sm:gap-4 md:gap-6 lg:gap-10 px-4 sm:px-6 lg:px-12">
      {/* Left - Phone mockup (hidden on mobile) */}
      <div className="hidden sm:flex flex-1 items-end justify-center">
        <img
          src="/Site_WordSort/WordSortMobileHand.png"
          alt="WordSortMobileHand"
          className="w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/2"
        />
      </div>

      {/* Center - Logo + Tagline stacked */}
      <div className="flex flex-col items-center justify-center gap-3 sm:gap-4 md:gap-5 lg:gap-6 xl:gap-8 flex-1">
        <img
          src="/Site_WordSort/Logo_nobg.png"
          alt="Word Sort Logo"
          className="w-28 sm:w-28 md:w-32 lg:w-36 xl:w-40"
        />
        <img
          src="/Site_WordSort/PlaceEveryWord.png"
          alt="Place Every Word"
          className="w-36 sm:w-36 md:w-40 lg:w-48 xl:w-52"
        />
      </div>

      {/* Right - Subtitle + Download */}
      <div className="flex flex-col items-center justify-center gap-4 sm:gap-5 md:gap-6 lg:gap-8 flex-1">
        <img
          src="/Site_WordSort/WordPlayThatFlows.png"
          alt="Word Play That Flows"
          className="w-40 sm:w-40 md:w-44 lg:w-52 xl:w-60"
        />
        <DownloadFunctionality arrayHref={arrayHref} />
      </div>
    </div>
  );
};
